export const SET_AGGREGATED_CUSTOM_AGENCY_FEES =
  "SET_AGGREGATED_CUSTOM_AGENCY_FEES";
export const SET_GROUPED_CUSTOM_AGENCY_FEES = "SET_GROUPED_CUSTOM_AGENCY_FEES";
export const SET_IS_FETCHING_AGGREGATED_CUSTOM_AGENCY_FEES =
  "SET_IS_FETCHING_AGGREGATED_CUSTOM_AGENCY_FEES";
export const SET_IS_FETCHING_GROUPED_CUSTOM_AGENCY_FEES =
  "SET_IS_FETCHING_GROUPED_CUSTOM_AGENCY_FEES";

export default {
  [SET_GROUPED_CUSTOM_AGENCY_FEES](state, groupedFees) {
    state.groupedCustomAgencyFees = groupedFees;
  },
  [SET_AGGREGATED_CUSTOM_AGENCY_FEES](state, aggregatedFees) {
    state.aggregatedCustomAgencyFees = aggregatedFees;
  },
  [SET_IS_FETCHING_AGGREGATED_CUSTOM_AGENCY_FEES](state, isFetching) {
    state.isFetchingAggregatedCustomAgencyFee = isFetching;
  },
  [SET_IS_FETCHING_GROUPED_CUSTOM_AGENCY_FEES](state, isFetching) {
    state.isFetchingGroupedCustomAgencyFee = isFetching;
  }
};
